<template>
    <div>
        Congratulations! <br/>
        You have received &pound;{{ globalRewardAmount }} reward for referring
        {{ notification.relations.referee.first_name }}.
        <hr>
        <router-link :to="{name: 'ProfileRewards'}" type="button"
                     class="btn btn-outline-info btn-lg float-right">View my rewards
        </router-link>
    </div>
</template>

<script>
import RewardHelper from "@/mixins/RewardHelper";

export default {
    name: "RefereeRegistered",
    mixins: [RewardHelper],
    props: {
        notification: Object
    },
}
</script>

<style scoped>

</style>
